import classNames from 'classnames';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCheckoutState } from '../../../utils/checkoutState';
import { getAssetUrl } from '../../../utils/config';
import { getStepFromRoute, steps } from '../../../utils/routing';
import './style.scss';

const BreadCrumbs = () => {
  const { checkoutState } = useCheckoutState();
  const { pathname } = useLocation();
  const currentStep = getStepFromRoute(pathname);
  const navigate = useNavigate();

  const availableSteps = checkoutState.customer ? steps.filter(step => step !== 'auth') : steps;

  const enabledSteps = {
    auth: !!checkoutState.customer,
    shipping: !!checkoutState.orderState.addresses?.shipping,
    payment: !!checkoutState.orderState.addresses?.billing,
  };

  return (
    <div className="breadcrumbs">
      {availableSteps.map((step, index) => (
        <Fragment key={step}>
          {!!index && <img src={getAssetUrl('header/chevronRight.svg')} alt="right" className="breadcrumbs__chevron" />}
          <div
            className={classNames('breadcrumbs__item', { 'breadcrumbs__item--active': currentStep === step })}
            onClick={() => enabledSteps[step] && navigate(`/${step}`)}
          >
            <FormattedMessage id={`header.${step}`} />
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default BreadCrumbs;
